import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
} from "../../../assets/images/index";

const BestSellers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Our Bestsellers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1011"
          img={bestSellerOne}
          productName="Food Street"
          price="Inquire"
          color="Delhi , India"
          badge={true}
          des="Tour Food Street is a vibrant and bustling area known for its diverse culinary offerings. From street food stalls to fine dining restaurants, visitors can indulge in a variety of flavors and cuisines. The lively atmosphere, combined with the aroma of freshly cooked dishes, makes it a must-visit destination for food enthusiasts.  "
        />
        <Product
          _id="1012"
          img={bestSellerTwo}
          productName="Tour Food "
          price="Inquire"
          color="Delhi , India"
          badge={false}
          des="Tour Food Street is a vibrant and bustling area known for its diverse culinary offerings. From street food stalls to fine dining restaurants, visitors can indulge in a variety of flavors and cuisines. The lively atmosphere, combined with the aroma of freshly cooked dishes, makes it a must-visit destination for food enthusiasts.  "
        />
        <Product
          _id="1013"
          img={bestSellerThree}
          productName="Tour Experience"
          price="Inquire"
          color="Delhi , India"
          badge={true}
          des="Tour Experience is a unique opportunity to immerse yourself in the rich culture and history of Delhi. From exploring ancient monuments to savoring delicious local cuisine, this tour offers an unforgettable journey through the heart of the city."
        />
        <Product
          _id="1014"
          img={bestSellerFour}
          productName="Different Food Culture"
          price="Inquire"
          color="Delhi , India"
          badge={false}
          des="Tour Different Food Culture is a delightful journey through the diverse culinary landscape of Delhi. From traditional street food to modern fusion dishes, visitors can experience the rich tapestry of flavors that define the city's food culture."
        />
      </div>
    </div>
  );
};

export default BestSellers;
